import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontMedium, ZeeFontRegular } from 'src/styles/font';
import { flex } from 'src/styles/utils';
import { Commerce } from 'src/utils/constants/CommerceConstants';

import { MediaBP as MQ } from '../../../../styles/mediaQuery';

// background: url(https://imgstg.zee5.com/image/upload/w_auto,f_auto/v1695376600/commerce/poster_1.png)
export const CommerceBannerWrapper = styled.div`
  height: 126px;
  width: 101vw;
  position: relative;
  margin: 24px -16px;
  background: url(${Commerce.IMG_PATH.replace(
      '<name>',
      Commerce.COMMERCE_BANNER
    )})
    no-repeat bottom right;
  background-size: cover;
  ${MQ.MediaSm} {
    height: 158px;
    margin: 24px -20px;
    // background-size: 60% 155px;
  }
  ${MQ.MediaMd} {
    height: 188px;
    margin: 24px -48px;
    // background-size: 55% 175px;
  }
  ${MQ.MediaLg} {
    height: 132px;
    width: 100%;
    border-radius: 8px;
    margin: 0 0 16px;
    // background-size: 85% 135px;
  }
  ${MQ.MediaXl} {
    height: 158px;
    // background-size: 70% 165px;
  }
`;

const slideIn = keyframes`
  0% { transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;
export const AnimatedBanner = styled.div`
  animation: ${slideIn} 0.7s ease-in-out;
`;

export const GradientContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  padding: 16px;
  ${flex('column', 'space-between', 'flex-start')}
  background: linear-gradient(
      0deg,
      ${colors.PrimaryBlackColorAlpha20},
      ${colors.PrimaryBlackColorAlpha20}
    ),
    linear-gradient(
      92.69deg,
      ${colors.DarkPurple} 32.55%,
      ${colors.PurpleAlpha0} 83.71%
    );
  ${MQ.MediaSm} {
    gap: 12px;
    padding: 20px;
  }
  ${MQ.MediaMd} {
    gap: 16px;
    padding: 20px 40px;
  }
  ${MQ.MediaLg} {
    gap: 8px;
    padding: 16px;
    border-radius: 8px;
    justify-content: space-between;
  }
  ${MQ.MediaXl} {
    gap: 12px;
  }
`;

export const titleContainer = (productsWishlisted: number) => css`
  ${flex('column', 'center', 'flex-start')}
  gap: 4px;
  width: ${productsWishlisted ? 'auto' : '45%'};
  ${MQ.MediaSm} {
    width: ${productsWishlisted ? 'auto' : '28%'};
  }
  ${MQ.MediaMd} {
    width: ${productsWishlisted ? 'auto' : '26%'};
  }
  ${MQ.MediaLg} {
    width: ${productsWishlisted ? 'auto' : '40%'};
  }
  ${MQ.MediaXl} {
    width: ${productsWishlisted ? 'auto' : '36%'};
  }
`;

export const Title = styled.span`
  ${ZeeFontBold(12, 18)};
  ${MQ.MediaSm} {
    ${ZeeFontBold(18, 24)};
  }
  ${MQ.MediaMd} {
    ${ZeeFontBold(24, 36)};
  }
  ${MQ.MediaLg} {
    ${ZeeFontBold(14, 20)};
  }
  ${MQ.MediaXl} {
    ${ZeeFontBold(16, 22)};
  }
`;

export const SubTitle = styled.span`
  ${ZeeFontMedium(11, 16)};
  ${MQ.MediaSm} {
    ${ZeeFontMedium(14, 20)};
  }
  ${MQ.MediaMd} {
    ${ZeeFontMedium(16, 22)};
  }
  ${MQ.MediaLg} {
    ${ZeeFontMedium(12, 18)};
  }
  ${MQ.MediaXl} {
    ${ZeeFontMedium(14, 20)};
  }
`;

export const ButtonContainer = styled.div`
  ${flex('row', '', 'flex-start')}
  gap: 12px;
`;

export const wishlist = css`
  height: 32px;
  width: 100%;
  padding: 4px 16px;
  min-width: 125px;
  background: ${colors.Transparent};
  color: ${colors.PrimaryWhiteColor};
  border: 1px solid ${colors.PrimaryWhiteColor};
  ${ZeeFontMedium(12, 18)};
  ${MQ.MediaSm} {
    height: 38px;
    width: 120px;
    padding: 8px 10px;
    ${ZeeFontRegular(14, 22)};
  }
  ${MQ.MediaMd} {
    height: 48px;
    width: 150px;
    padding: 12px 18px;
    ${ZeeFontMedium(16, 22)};
  }
  ${MQ.MediaLg} {
    height: 32px;
    width: 108px;
    min-width: 104px;
    padding: 4px 10px;
    ${ZeeFontMedium(12, 18)};
  }
  ${MQ.MediaXl} {
    height: 48px;
    width: 148px;
    padding: 12px 18px;
    ${ZeeFontBold(16, 22)};
  }
  &:hover {
    color: ${colors.AppBgColor};
    border: none;
    background: ${colors.PrimaryWhiteColor};
    transition: background-color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  }
`;

export const explore = css`
  height: 32px;
  padding: 4px 10px;
  min-width: 125px;
  background: ${colors.PurpleBtn};
  color: ${colors.PrimaryWhiteColor};
  ${ZeeFontMedium(12, 18)};
  ${MQ.MediaSm} {
    height: 38px;
    width: 120px;
    padding: 8px 10px;
    ${ZeeFontRegular(14, 22)};
  }
  ${MQ.MediaMd} {
    height: 48px;
    width: 150px;
    padding: 12px 18px;
    ${ZeeFontMedium(16, 22)};
  }
  ${MQ.MediaLg} {
    height: 32px;
    width: 109px;
    padding: 4px 10px;
    ${ZeeFontMedium(12, 18)};
  }
  ${MQ.MediaXl} {
    height: 48px;
    width: 148px;
    padding: 12px 18px;
    ${ZeeFontBold(16, 22)};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &:hover {
    color: ${colors.PrimaryWhiteColor};
    border: none;
    background: ${colors.PurpleBtnHover};
    transition: background-color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  }
`;
